import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "services/api";
import { Badge, ProgressBar, Form } from "react-bootstrap";
import VipLevelText from "elements/VipLevelText";
import InputBox from "elements/InputBox";
import { __ } from "services/Translator";

export default function ProfileDetails(props) {
  const isAuthenticated = props.isAuthenticated;
  const userDetails = props.userDetails;
  const userBalance = props.userBalance;
  const accountProgress = props.accountProgress;
  const getAccountProgress = props.getAccountProgress;
  const setSpinner = props.setSpinner;
  // const [isAnonymous, setIsAnonymous] = useState(true);

  // const __ = (text) => text;

  const genders = [
    { label: __("Gender"), value: null },
    { label: __("Male"), value: "Male" },
    { label: __("Female"), value: "Female" },
    { label: __("Other"), value: "Other" },
  ];

  const [countries, setCountries] = useState([]);
  const [languages, setLanguages] = useState([]);
  const currencies = [
    { label: __("Currency"), value: null },
    { label: "USD", value: "USD" },
  ];
  const [phoneCodes, setPhoneCodes] = useState([]);

  const getCountries = async () => {
    var response = await api.get("/countries");
    if (response.status === 200) {
      setCountries(
        response.data.map((val) => {
          return { label: val.nicename, value: val.code };
        })
      );
      setPhoneCodes(
        response.data.map((val) => {
          return {
            label: "+" + val.phonecode + " (" + val.code + ")",
            value: "+" + val.phonecode,
          };
        })
      );
    } else {
      props.showAlert("Warning!!", response.data.message);
    }
  };

  const getLanguages = async () => {
    var response = await api.get("/languages");
    if (response.status === 200) {
      setLanguages(
        response.data.map((val) => {
          return { label: val.language, value: val.code };
        })
      );
    } else {
      props.showAlert("Warning!!", response.data.message);
    }
  };

  const getProfile = async () => {
    setSpinner(true);
    var response = await api.get("/profile");
    setSpinner(false);
    if (response.status === 200) {
      setForm(response.data);
      props.setIsAnonymous(parseInt(response.data.isAnonymous));
      setIsDataFetched(true);
    } else {
      props.showAlert("Warning!!", response.data.message);
    }
  };

  const [editMode, setEditMode] = useState(false);

  const submitProfile = async (ev) => {
    ev.preventDefault();
    setSpinner(true);
    var response = await api.post("/profile/save", {
      oldPassword: form.oldPassword,
      password: form.password,
      repassword: form.repassword,
    });
    setSpinner(false);
    if (response.status === 200) {
      props.showAlert("Success!!", response.data.message);
      setForm({
        ...form,
        oldPassword: "",
        password: "",
        repassword: "",
      });
      setIsDataFetched(true);
    } else {
      props.showAlert("Warning!!", response.data.message, true);
    }
  };

  const [isDataFetched, setIsDataFetched] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    dateOfBirth: "",
    gender: "",
    currency: "",
    language: "",
    phoneCode: "",
    phone: "",
  });

  const updateForm = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const getAllData = async (force) => {
    if (!isDataFetched || force) {
      setSpinner(true);
      await getCountries();
      await getLanguages();
      await getProfile();
      // setSpinner(false);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const toggleAnonymousSettings = async () => {
    props.setIsAnonymous(!parseInt(props.isAnonymous));

    props.setSpinner(true);
    var response = await api.post("/toggle-anonymous-settings", {
      isAnonymous: !props.isAnonymous,
    });
    props.setSpinner(false);
    if (response.status === 200) {
      props.showAlert("Success!!", response.data.message);
    } else {
      props.showAlert("Warning!!", response.data.message, true);
    }
  };

  const toggleTwoFASettings = async () => {
    setForm({ ...form, twoFaEnabled: !form.twoFaEnabled });
    props.setSpinner(true);
    var response = await api.post("/toggle-twofa-settings");
    props.setSpinner(false);
    if (response.status === 200) {
      props.showAlert("Success!!", response.data.message);
    } else {
      setForm({ ...form, twoFaEnabled: !!form.twoFaEnabled });
      props.showAlert("Warning!!", response.data.message, true);
    }
  };

  return (
    <>
      <h3 className="tabName white">
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M27.3137 5.18628C24.2917 2.16431 20.2737 0.5 16 0.5C11.7263 0.5 7.70825 2.16431 4.68628 5.18628C1.66431 8.20825 0 12.2263 0 16.5C0 20.7737 1.66431 24.7917 4.68628 27.8137C7.70825 30.8357 11.7263 32.5 16 32.5C20.2737 32.5 24.2917 30.8357 27.3137 27.8137C30.3357 24.7917 32 20.7737 32 16.5C32 12.2263 30.3357 8.20825 27.3137 5.18628ZM6.94409 27.3311C7.47241 22.7852 11.3809 19.2754 16 19.2754C18.4351 19.2754 20.7249 20.2241 22.4473 21.9463C23.9023 23.4016 24.8201 25.3018 25.0562 27.3308C22.6025 29.3857 19.4434 30.625 16 30.625C12.5566 30.625 9.39771 29.386 6.94409 27.3311ZM16 17.3442C13.3206 17.3442 11.1404 15.1641 11.1404 12.4846C11.1404 9.80493 13.3206 7.625 16 7.625C18.6794 7.625 20.8596 9.80493 20.8596 12.4846C20.8596 15.1641 18.6794 17.3442 16 17.3442ZM26.6699 25.7458C26.1921 23.8196 25.1958 22.0435 23.7729 20.6206C22.6206 19.4683 21.2573 18.6038 19.7705 18.062C21.5579 16.8499 22.7346 14.802 22.7346 12.4846C22.7346 8.77124 19.7134 5.75 16 5.75C12.2866 5.75 9.26538 8.77124 9.26538 12.4846C9.26538 14.8032 10.4431 16.8518 12.2319 18.0637C10.864 18.5623 9.59814 19.333 8.50903 20.3477C6.93188 21.8164 5.83667 23.6892 5.32886 25.7444C3.17822 23.2651 1.875 20.032 1.875 16.5C1.875 8.71143 8.21143 2.375 16 2.375C23.7886 2.375 30.125 8.71143 30.125 16.5C30.125 20.0327 28.8213 23.2666 26.6699 25.7458Z"
            fill="white"
          />
        </svg>{" "}
        {__("Account Details")}
      </h3>

      <div className="user_blocks">
        <div className="profile_settings">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="profile_settings_left">
                <div className="casino_id">
                  {__("ID Casino Number")} : <b>{form.pin}</b>
                </div>
                <div className="edit_btn">
                  <Link onClick={() => setEditMode(true)} className="common_btn_v1 inactive gray medium">
                    {__("Edit Account")}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 text-end">
              <div className="profile_settings_right">
                <div className="setting_switch">
                  <label>{__("Anonymous")}</label>
                  <Form.Check
                    checked={props.isAnonymous}
                    type="switch"
                    onChange={toggleAnonymousSettings}
                    id="anonymous_mode"
                  />
                </div>
                <div className="setting_switch">
                  <label>{__("2FA ")}</label>
                  <Form.Check
                    checked={form.twoFaEnabled}
                    type="switch"
                    onChange={toggleTwoFASettings}
                    id="anonymous_mode"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="single_block user_details_v1">
          <div className="item">
            <div className="user_item">
              <div className="name">
                <span>Lv {form.identity} -</span>
                <span className="colored">
                  <VipLevelText identity={form.identity} />
                </span>
                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.3999 17C13.1678 17.0002 12.9392 16.9433 12.734 16.8343L8.92296 14.8234C8.89343 14.8075 8.86046 14.7993 8.82697 14.7993C8.79348 14.7993 8.76051 14.8075 8.73097 14.8234L4.92051 16.8343C4.68438 16.959 4.41818 17.0149 4.15204 16.9957C3.8859 16.9764 3.63044 16.8828 3.41457 16.7253C3.19869 16.5679 3.03102 16.3529 2.93052 16.1048C2.83003 15.8566 2.80072 15.5852 2.84591 15.3212L3.57352 11.0619C3.57911 11.0285 3.57646 10.9943 3.5658 10.9622C3.55514 10.9301 3.53679 10.9011 3.51237 10.8778L0.431963 7.8596C0.240707 7.67254 0.105462 7.43545 0.0415516 7.17518C-0.0223591 6.91491 -0.0123804 6.64187 0.0703572 6.387C0.153095 6.13214 0.305283 5.90563 0.50968 5.73314C0.714076 5.56065 0.962508 5.44908 1.22683 5.41107L5.48425 4.7905C5.51738 4.78566 5.54884 4.77279 5.5759 4.75301C5.60296 4.73322 5.62481 4.70711 5.63956 4.67694L7.54295 0.800669C7.66085 0.560371 7.84341 0.358012 8.06996 0.216506C8.29651 0.0749994 8.55801 0 8.82483 0C9.09165 0 9.35314 0.0749994 9.5797 0.216506C9.80625 0.358012 9.98881 0.560371 10.1067 0.800669L12.0113 4.67572C12.0262 4.70579 12.0481 4.73182 12.0751 4.75159C12.1022 4.77136 12.1336 4.78428 12.1666 4.78927L16.4277 5.41046C16.6919 5.44869 16.9402 5.56038 17.1444 5.73289C17.3487 5.9054 17.5008 6.13186 17.5835 6.38663C17.6662 6.64141 17.6762 6.91433 17.6124 7.17453C17.5487 7.43474 17.4136 7.67183 17.2226 7.85899L14.1391 10.8753C14.1148 10.8987 14.0965 10.9277 14.0858 10.9598C14.0752 10.9919 14.0725 11.0261 14.078 11.0594L14.8056 15.3187C14.8406 15.5245 14.8305 15.7355 14.776 15.937C14.7215 16.1385 14.624 16.3257 14.4901 16.4854C14.3563 16.6452 14.1893 16.7738 14.001 16.8623C13.8126 16.9507 13.6072 16.9969 13.3993 16.9975L13.3999 17ZM8.82697 13.5712C9.05886 13.5711 9.28725 13.628 9.49221 13.7369L13.3027 15.7472C13.3364 15.7665 13.3751 15.7754 13.4138 15.7727C13.4526 15.77 13.4896 15.7557 13.5203 15.7318C13.5524 15.7098 13.5773 15.6788 13.5919 15.6427C13.6066 15.6066 13.6104 15.5669 13.6029 15.5287L12.8747 11.2688C12.8358 11.0395 12.8528 10.8042 12.9244 10.583C12.996 10.3618 13.1199 10.1613 13.2856 9.99876L16.369 6.98184C16.3965 6.95478 16.416 6.92053 16.4252 6.88296C16.4343 6.84539 16.4328 6.806 16.4209 6.76923C16.4089 6.73246 16.387 6.69978 16.3575 6.67487C16.328 6.64996 16.2922 6.63383 16.2541 6.62828L11.9936 6.00648C11.7642 5.97314 11.5464 5.88423 11.3589 5.74745C11.1714 5.61067 11.0199 5.43012 10.9175 5.2214L9.0104 1.34574C8.99332 1.31106 8.96692 1.28186 8.93418 1.26144C8.90145 1.24103 8.86367 1.23021 8.82513 1.23021C8.7866 1.23021 8.74882 1.24103 8.71609 1.26144C8.68335 1.28186 8.65695 1.31106 8.63987 1.34574L6.73647 5.22018C6.63399 5.42897 6.48239 5.60957 6.29479 5.74636C6.10719 5.88314 5.88922 5.972 5.65973 6.00525L1.39987 6.62828C1.36166 6.6337 1.32573 6.64979 1.29619 6.67471C1.26664 6.69963 1.24466 6.73238 1.23274 6.76922C1.22082 6.80607 1.21945 6.84553 1.22879 6.88312C1.23812 6.92071 1.25778 6.95492 1.28553 6.98184L4.36838 9.99876C4.53405 10.1613 4.65798 10.3618 4.72954 10.583C4.80111 10.8042 4.81817 11.0395 4.77927 11.2688L4.05105 15.5287C4.04444 15.5669 4.04867 15.6063 4.06325 15.6423C4.07783 15.6783 4.10218 15.7094 4.13353 15.7322C4.16488 15.755 4.20196 15.7684 4.24056 15.7711C4.27916 15.7737 4.31773 15.7655 4.35187 15.7472L8.16173 13.7363C8.36683 13.6279 8.59516 13.5712 8.82697 13.5712Z"
                    fill="#4DE8FF"
                  />
                </svg>
              </div>
              <div className="progress_value">{accountProgress}%</div>
            </div>
            <div className="progress_bar">
              <ProgressBar now={accountProgress} />
            </div>
          </div>

          <div className="item">
            <div className="input_label">{__("Email")}</div>
            <input disabled={true} value={form.email} className="form-controll input_box" type="email" />
          </div>
          <div className="item">
            <div className="input_label">{__("Currency")}</div>
            <input disabled={true} className="form-controll input_box" value={form.currency} type="text" />
          </div>
        </div>
        <div className="single_block address_area">
          <div className="item">
            <div className="input_label">{__("First Name")}</div>
            <input disabled={true} className="form-controll input_box" value={form.firstName} type="text" />
          </div>
          <div className="item">
            <div className="input_label">{__("Last Name")}</div>
            <input disabled={true} className="form-controll input_box" value={form.lastName} type="text" />
          </div>

          <div className="item">
            <div className="input_label">{__("Username")}</div>
            <input disabled={true} className="form-controll input_box" value={form.playerLogin} type="text" />
          </div>
        </div>

        <div className="single_block address_area">
          <div className="item">
            <div className="input_label">{__("Occupation")}</div>
            <input disabled={true} className="form-controll input_box" value={form.occupation} type="text" />
          </div>
          <div className="item">
            <div className="input_label">{__("Birthday")}</div>
            <input disabled={true} className="form-controll input_box" value={form.dateOfBirth} type="text" />
          </div>
          <div className="item">
            <div className="input_label">{__("Address")}</div>
            <input
              disabled={true}
              className="form-controll input_box"
              value={form.address + (form.city ? ", " + form.city : "")}
              type="text"
            />
          </div>
        </div>

        <div className="single_block address_area">
          <div className="item">
            <div className="input_label">{__("Country")}</div>
            <input
              disabled={true}
              className="form-controll input_box"
              value={countries?.filter((item) => item.value === form.country)[0]?.label}
              type="text"
            />
          </div>
          <div className="item">
            <div className="input_label">{__("States")}</div>
            <input disabled={true} className="form-controll input_box" value={form.state} type="text" />
          </div>
          <div className="item">
            <div className="input_label">{__("Zip Code")}</div>
            <input disabled={true} className="form-controll input_box" value={form.zip} type="text" />
          </div>
        </div>
        {editMode && (
          <>
            <br />
            <br />
            <h5 className="white">Change Password</h5>
            <div className="single_block address_area">
              <div className="item">
                <div className="input_label">{__("Old Password")}</div>
                <InputBox
                  className="form-controll input_box"
                  value={form.oldPassword}
                  onChange={(value) => updateForm(value, "oldPassword")}
                  type="password"
                />
              </div>
              <div className="item">
                <div className="input_label">{__("Password")}</div>
                <InputBox
                  className="form-controll input_box"
                  value={form.password}
                  onChange={(value) => updateForm(value, "password")}
                  type="password"
                />
              </div>
              <div className="item">
                <div className="input_label">{__("Re-type Password")}</div>
                <InputBox
                  className="form-controll input_box"
                  value={form.repassword}
                  onChange={(value) => updateForm(value, "repassword")}
                  type="password"
                />
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button onClick={submitProfile} className="common_btn_v1 gray">
                {__("Update Password")}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
